<template>
  <el-dialog
    title="选择置顶商品"
    :visible.sync="dialog"
    width="600px"
    style="text-align:left;"
    :close-on-click-modal="false"
    append-to-body
    class="big"
    :show-close="false"
  >
    <div class="content">
      <div>
        <el-input
          v-model="keywords"
          placeholder="请输入商品"
          style="width:200px"
        ></el-input>
        <el-button
          type="primary"
          @click="getList"
          style="margin-left:20px"
        >查询</el-button>
      </div>
      <div class="list-box">
        <div
          class="flex align-center"
          v-for="item in list"
          :key="item.goods_id"
        >
          <el-checkbox v-model="item.checked"></el-checkbox>
          <img
            :src="item.img_url"
            alt
          />
          <div>{{item.goods_name}}</div>
        </div>
      </div>
    </div>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      keywords: '',
      dialog: true,
      page: 1,
      total: 0,
      list: []
    };
  },
  mounted() {
    this.getList();
  },
  props: {
    category_id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    getList() {
      let data = {
        category_id: this.category_id,
        keywords: this.keywords,
        pageNumber: 1000
      };
      this.axios
        .post('platform/ManageGoods/searchTopGoodInfo', data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            ele.checked = false;
          });
          this.list = list;
        });
    },
    close() {
      this.$emit('close');
    },
    checkGood(item) {
      item.checked = !item.checked;
    },
    submit() {
      let list = this.list.filter((ele) => {
        return ele.checked;
      });
      this.$emit('checkGoods', list);
      this.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 30px 30px 0;
  box-sizing: border-box;
}
.list-box {
  height: 400px;
  overflow: auto;
  margin-top: 15px;
  & > div {
    margin-bottom: 10px;
  }
  img {
    height: 70px;
    width: auto;
    margin: 0 15px;
  }
}
</style>
